import { render, staticRenderFns } from "./InstructionAdvancedProps.vue?vue&type=template&id=076acc4f"
import script from "./InstructionAdvancedProps.vue?vue&type=script&lang=js"
export * from "./InstructionAdvancedProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports